import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 2rem;
  text-align: left;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #005eb8;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  list-style-position: inside;
  padding-left: 1rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 0.5rem;
`;

const CodeOfPractice = () => {
    return (
        <PageContainer>
            <PageTitle>Code of Practice</PageTitle>

            <Section>
                <Paragraph>
                    The Letter Doctor is committed to providing a safe and high-quality service to all our users. This Code of Practice outlines the standards we adhere to, ensuring transparency, professionalism, and trust.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>Our Doctors</SectionTitle>
                <Paragraph>
                    All medical services provided by The Letter Doctor are delivered by UK-based doctors who are registered with the General Medical Council (GMC). Our doctors:
                </Paragraph>
                <List>
                    <ListItem>Hold a full license to practice.</ListItem>
                    <ListItem>Are in good standing with the GMC.</ListItem>
                    <ListItem>Have extensive experience working within the NHS and/or private practice.</ListItem>
                    <ListItem>Adhere to the principles of Good Medical Practice as set out by the GMC.</ListItem>
                    <ListItem>Engage in regular appraisals and revalidation to maintain their skills and knowledge.</ListItem>
                </List>
            </Section>

            <Section>
                <SectionTitle>Our Service</SectionTitle>
                <Paragraph>
                    We provide a range of medical letters, certificates, and referrals based on the information you provide. Our service is designed to be convenient and efficient, but it is not a substitute for a face-to-face consultation with your regular GP, especially for complex or ongoing medical issues.
                </Paragraph>
                <Paragraph>
                    Our doctors will review your request and the information provided in your questionnaire. They will only issue a letter or certificate if they are satisfied that it is clinically appropriate and safe to do so. If we are unable to provide the requested document, a full refund will be issued.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>Your Information</SectionTitle>
                <Paragraph>
                    We take the security and confidentiality of your personal and medical information very seriously.
                </Paragraph>
                <List>
                    <ListItem>We are registered with the Information Commissioner's Office (ICO) and comply with all data protection legislation, including the General Data Protection Regulation (GDPR).</ListItem>
                    <ListItem>Your data is stored securely using encrypted systems.</ListItem>
                    <ListItem>We will never share your information with third parties without your explicit consent, unless required to do so by law.</ListItem>
                </List>
            </Section>

            <Section>
                <SectionTitle>Safeguarding</SectionTitle>
                <Paragraph>
                    The Letter Doctor is committed to safeguarding children and vulnerable adults. If any information provided raises a safeguarding concern, our doctors have a professional and legal duty to take appropriate action, which may include contacting relevant authorities.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>Feedback and Complaints</SectionTitle>
                <Paragraph>
                    We welcome all feedback as it helps us to improve our service. If you have any comments, suggestions, or complaints, please contact us via our <Link to="/contact">Contact Us</Link> page. We have a formal complaints procedure and aim to resolve any issues promptly and fairly.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>Our Details</SectionTitle>
                <Paragraph>
                    The Letter Doctor is a trading name of [Your Company Name Ltd].<br />
                    Registered in England and Wales. Company No: [Your Company Number].<br />
                    Registered Office: [Your Registered Address].
                </Paragraph>
            </Section>
        </PageContainer>
    );
};

export default CodeOfPractice;